export default __webpack_public_path__ + "static/media/apostle-empty.ee40a1af.png";